import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { AddProductGroupingInput } from './AddProductGroupingInput';
import { AddProductGroupingOutput } from './AddProductGroupingOutput';

export class AddProductGroupingService extends HttpServiceBase {

  constructor(
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: AddProductGroupingInput): Promise<Result<AddProductGroupingOutput> | null> => {
    const promise = this.http.post<Result<AddProductGroupingOutput>, AddProductGroupingInput>(`${this.baseUrlSislogApi}/v2/product-grouping/add`, input);
    return promise;
  }
}